export default __webpack_public_path__ + "images/888dc30cb6c4dbe9d017a522819ed0d6.svg";